<div class="relative inline-block text-left" #dropdownContainer>
  <ng-content select="[appDropdownTrigger]"></ng-content>

  @if (isOpen()) {
    <div [class]="contentClasses">
      <ng-content></ng-content>
    </div>
  }
</div>
